<lib-splash [completedHandler]="goToHome"></lib-splash>